// extracted by mini-css-extract-plugin
module.exports = {"rtl":"-YjC_","ltr":"_2CPLm"};